export enum PhysicalVerificationType {
  drivingLicense = 'driving_license',
  idCard = 'id_card',
  pass = 'passport',
  controlQuestion = 'control_question',
}

export enum VerificationText {
  driving_license = 'Førerkort',
  id_card = 'Nasjonalt ID-kort',
  passport = 'Pass',
  control_question = 'Sikkerhetsspørsmål',
  bankid = 'BankID',
  two_factor_authentication = '2FA',
}

export enum VerificationType {
  physical = 'physical',
  bankID = 'bankID',
  TwoFA = 'TwoFactorAuthentication',
}
